import { initGraphQLTada } from 'gql.tada'
import type { introspection } from './graphql-env.d.ts'
import type { Scalars } from './scalars'

/**
 * Tagged GraphQL function of this repository.
 *
 * Result and variable types of every operation are inferred from the committed API schema at
 * type-check time, so no generation step runs after editing an operation. A field the schema
 * does not know is typed `unknown`; `gql.tada check` (the `graphql:check` task) reports it as a
 * validation error, as do editors with the `@0no-co/graphqlsp` TypeScript plugin.
 */
export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: Scalars
}>()

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada'
export { readFragment } from 'gql.tada'
